"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertReducer = void 0;
const Keys_1 = require("./Keys");
const initialState = {
    danger: [],
    info: [],
    success: [],
    warning: [],
};
const warnings = (id) => ({
    skip: `Skip adding alert with Id: "${id}".`,
    notFound: `Alert with Id: "${id}" doesn't exist.`,
});
const addAlertToState = (state, payload) => {
    const alert = state[payload.type].find((a) => a.id === payload.id);
    if (alert) {
        console.warn(warnings(payload.id).skip);
        return state;
    }
    state[payload.type].push(payload);
    return state;
};
const hideAlert = (state, payload) => {
    const index = state[payload.type].findIndex((a) => a.id === payload.id);
    if (!(index > -1)) {
        console.warn(warnings(payload.id).notFound);
        return state;
    }
    state[payload.type][index].state = Keys_1.ToggleType.Hide;
    return state;
};
const removeAlert = (state, payload) => {
    const index = state[payload.type].findIndex((a) => a.id === payload.id);
    if (!(index > -1)) {
        console.warn(warnings(payload.id).notFound);
        return state;
    }
    state[payload.type].splice(index, 1);
    return state;
};
const showAlert = (state, payload) => {
    const index = state[payload.type].findIndex((a) => a.id === payload.id);
    if (!(index > -1)) {
        console.warn(warnings(payload.id).notFound);
        return state;
    }
    state[payload.type][index].state = Keys_1.ToggleType.Show;
    return state;
};
const toggle = (state, payload) => {
    if (payload.state === Keys_1.ToggleType.Hide) {
        return hideAlert(state, payload);
    }
    if (payload.state === Keys_1.ToggleType.Show) {
        return showAlert(state, payload);
    }
    return state;
};
const alertReducer = (state = initialState, action) => {
    switch (action.type) {
        case Keys_1.AlertActionTypes.Add:
            return {
                ...state,
                ...addAlertToState(state, action.payload),
            };
        case Keys_1.AlertActionTypes.Clear:
            return initialState;
        case Keys_1.AlertActionTypes.Hide:
            return {
                ...state,
                ...hideAlert(state, action.payload),
            };
        case Keys_1.AlertActionTypes.Remove:
            return {
                ...state,
                ...removeAlert(state, action.payload),
            };
        case Keys_1.AlertActionTypes.Show:
            return {
                ...state,
                ...showAlert(state, action.payload),
            };
        case Keys_1.AlertActionTypes.Toggle:
            return {
                ...state,
                ...toggle(state, action.payload),
            };
        default:
            return state;
    }
};
exports.alertReducer = alertReducer;
